export default __webpack_public_path__ + "static/media/NIAS0300.34I-42864_-25601_0.df8bd9e4.jpg";